import React from "react";

function LogOutIcon() {
  return (
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.08 3.281c-2.832.182-5.254 1.542-6.69 3.759-.997 1.538-1.475 3.511-1.35 5.578.08 1.333.337 2.363.862 3.454.437.909.93 1.598 1.623 2.27 1.483 1.437 3.368 2.234 5.62 2.377.735.047.922.014 1.135-.199.409-.409.205-1.115-.358-1.236a2.95 2.95 0 0 0-.497-.044c-.977 0-2.274-.329-3.245-.823a5.909 5.909 0 0 1-1.54-1.085C5.215 15.977 4.52 14.229 4.52 12c0-1.691.387-3.047 1.233-4.32.288-.434 1.153-1.305 1.607-1.619 1.115-.769 2.776-1.301 4.065-1.301.453 0 .678-.063.855-.24.409-.409.205-1.115-.358-1.236a1.545 1.545 0 0 0-.294-.038l-.548.035m6.08 5.524a.923.923 0 0 0-.389.374c-.084.16-.079.49.009.662.039.076.369.441.733.809l.662.67H13.89c-2.93 0-4.32.013-4.397.043a.75.75 0 0 0-.464.697.75.75 0 0 0 .464.697c.077.03 1.467.043 4.397.043h4.285l-.662.67c-.364.368-.694.733-.733.809-.088.172-.093.502-.009.662a.756.756 0 0 0 .98.357c.181-.076 2.806-2.688 2.911-2.897a.918.918 0 0 0 .069-.341.918.918 0 0 0-.069-.341c-.105-.209-2.73-2.821-2.911-2.897a.93.93 0 0 0-.591-.017"
        fillRule="evenodd"
        fill="#ffffff"
      />
    </svg>
  );
}

export default LogOutIcon;
